import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import {Tooltip} from '@mui/material'
import {Box, Button} from '@viptech/react-components'
import {PortalViewSwitcher} from 'src/components/portal-migration/portal-view-switcher'
import useWindowSize from 'src/components/slider/hooks/useWindowSize'
import {useAuth} from 'src/contexts/AuthContext'
import openSidebar from 'src/images/iconSideBar.svg'
import {useAppSidebar} from 'src/layouts/main-layout/app-sidebar/app-sidebar-context'
import {cn} from 'src/layouts/main-layout/app-sidebar/utils/utils'
import {breadcrumbMap} from 'src/layouts/main-layout/header/components/route-breadcrumb/breadcrumb-map'
import {RouteBreadcrumb} from 'src/layouts/main-layout/header/components/route-breadcrumb/route-breadcrumb'
import {CompaniesExpirationDateMenu} from './components/CompaniesExpirationDateMenu'
import {NotificationsComponent} from './components/NotificationsComponent'
import {ProfileMenuComponent} from './components/ProfileMenuComponent'

export function Header() {
  const {userIsB2c} = useAuth()
  const {toggleCollapsed} = useAppSidebar()
  const {width} = useWindowSize()

  const mobileWidth = width <= 767
  return (
    <div data-slot='app-header' className='flex w-full items-center justify-between bg-white px-6'>
      <div data-slot='app-header-left' className={cn('flex items-center gap-24', mobileWidth && 'gap-6')}>
        {mobileWidth && (
          <button onClick={toggleCollapsed} className='shrink-0'>
            <img src={openSidebar} alt='abrir side bar' />
          </button>
        )}

        {!mobileWidth && (
          <div data-slot='app-header-logo'>
            <img src='/logo.svg' alt={'workspaceName'} className='h-6 w-auto' />
          </div>
        )}

        <RouteBreadcrumb map={breadcrumbMap} />
      </div>

      <Box display='flex' align='center' columnGap='13px'>
        <PortalViewSwitcher />
        {!userIsB2c && <CompaniesExpirationDateMenu />}
        <NotificationsComponent />

        <Tooltip title='Precisa de ajuda?'>
          <Button width='50%' color='transparent' hoverColor='transparent' padding='0' onClick={() => window.open('https://wa.me/5511931431860', 'blank')}>
            <WhatsAppIcon sx={{color: '#25D366', height: '20px', width: '20px'}} />
          </Button>
        </Tooltip>

        <ProfileMenuComponent />
      </Box>
    </div>
  )
}
